import ArrowDown from './arrow-down.svg';
import ArrowForward from './arrow-forward.svg';
import ArrowLeft from './arrow-left.svg';
import ArrowRight from './arrow-right.svg';
import ArrowUp from './arrow-up.svg';
import Banknote from './banknote.svg';
import Buildings from './buildings.svg';
import Calendar from './calendar.svg';
import Camera from './camera.svg';
import ChecklistCheckmark from './checklist-checkmark.svg';
import ChecklistCross from './checklist-cross.svg';
import Gameboy from './gameboy.svg';
import GameboyBlue from './gameboy-blue.svg';
import GraphUp from './graph-up.svg';
import Graph from './graph.svg';
import HandHeart from './hand-heart.svg';
import Healthy from './healthy.svg';
import Home from './home.svg';
import Level1 from './level1.svg';
import Level2 from './level2.svg';
import Level3 from './level3.svg';
import Level4 from './level4.svg';
import Level5 from './level5.svg';
import MemoryGame from './memory-game.svg';
import MenuButton from './menu-button.svg';
import MenuClose from './menu-close.svg';
import Microphone from './microphone.svg';
import Minus from './minus.svg';
import PlayBold from './play-bold.svg';
import Plus from './plus.svg';
import Progress from './progress.svg';
import Reading from './reading.svg'
import SocialFacebook from './social-facebook.svg';
import SocialInstagram from './social-instagram.svg';
import SocialTiktok from './social-tiktok.svg';
import SocialYoutube from './social-youtube.svg';
import Workbook from './workbook.svg';

const icons = {
  ArrowDown,
  ArrowForward,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  Banknote,
  Buildings,
  Calendar,
  Camera,
  ChecklistCheckmark,
  ChecklistCross,
  Gameboy,
  GameboyBlue,
  GraphUp,
  Graph,
  HandHeart,
  Home,
  Level1,
  Level2,
  Level3,
  Level4,
  Level5,
  MenuButton,
  MenuClose,
  Microphone,
  Minus,
  PlayBold,
  Plus,
  Reading,
  SocialFacebook,
  SocialInstagram,
  SocialTiktok,
  SocialYoutube,
  Workbook,
  Healthy,
  Progress,
  MemoryGame,
};

export default icons;
